import React, { createContext, useState } from 'react'
import Nav from "components/nav"
import Footer from "components/footer"
import { ThemeProvider } from '@emotion/react'
import * as styles from 'styles/exports.module.scss'
import Modal from 'react-bootstrap/Modal'
import xCloseWhite from 'images/x-close-white.svg'
import Button from 'react-bootstrap/Button'

export const Context = createContext()

export default function Layout({ children }) {
    const [modal, setModal] = useState(undefined)

    // https://emotion.sh/docs/theming
    const theme = {
        colors: {
            primary: styles.primary,
            black: styles.black,
            white: styles.white,
        },
        fonts: {
            inter: styles.inter,
            gothic: styles.gothic,
        },
        breakpoints: {
            xl: Number(styles.xl),
            lg: Number(styles.lg),
            md: Number(styles.md),
            sm: Number(styles.sm),
            xs: Number(styles.xs),
        },
        queries: {
            xl: `@media(max-width: ${styles.xl}px)`,
            lg: `@media(max-width: ${styles.lg}px)`,
            md: `@media(max-width: ${styles.md}px)`,
            sm: `@media(max-width: ${styles.sm}px)`,
            xs: `@media(max-width: ${styles.xs}px)`,
        },
        queriesMinWidth: {
            xl: `@media(min-width: ${styles.xl}px)`,
            lg: `@media(min-width: ${styles.lg}px)`,
            md: `@media(min-width: ${styles.md}px)`,
            sm: `@media(min-width: ${styles.sm}px)`,
            xs: `@media(min-width: ${styles.xs}px)`,
        },
    }

    return (
        <Context.Provider value={{ modal, setModal }}>
            <ThemeProvider theme={theme}>
                <Nav />
                <main>{children}</main>
                <Footer />
    
                <Modal show={modal} size='xl' centered onHide={() => setModal(undefined)}>
                    <Modal.Body className='p-0 border-0'>
                        {modal}
                    </Modal.Body>
                    <Button
                        variant=''
                        onClick={e => {
                            e.stopPropagation()
                            setModal(undefined)
                        }}
                        className='position-absolute'
                        style={{ padding: 40, right: -40, bottom: '100%' }}
                    >
                        <img src={xCloseWhite} alt='' height={20} />
                    </Button>
                </Modal>
            </ThemeProvider>
        </Context.Provider>
    )
}